var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
import Immutable from 'seamless-immutable';
import { createAction, handleActions } from 'redux-actions';
import { createSelector } from 'reselect';
import { ELSTokenHelper } from 'components/common';
import { appLinkingHelper } from 'helpers';
import { AppConstant, CS_APP_NAME, EAB_APP_NAME } from 'constants/app.constant';
import { appActions } from 'redux/ducks/app';
import { getBreadcrumbBackTitle, resolveOriginSrcApp } from 'helpers/app-linking.helper';
import { fetchSessionDataFromExternalApp } from 'services/app-linking.service';
import { getCourseSectionIsbns } from 'reports/cw/helpers/course-aggregate.helper';
import { fetchCourses, isCSAppByCourseSection } from 'reports/cw/services/courses.service';
import { EXTERNAL_APP_INFO } from 'constants/externalApp.constant';
var initialState = Immutable({
    courses: [],
    courseSectionInfo: null,
    isCourseFetching: false
});
var setCourses = createAction('COURSE/SET_COURSES');
var setCourseSectionInfo = createAction('COURSE/SET_COURSE_SECTION_INFO');
var restoreState = createAction('COURSE/RESTORE_STATE');
var setIsCourseFetching = createAction('COURSE/SET_IS_COURSE_FETCHING');
var getCourses = function (email) { return function (dispatch) { return fetchCourses(email).then(function (data) { return dispatch(setCourses(data)); }); }; };
var switchCourse = function (courseSectionId, userId) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var tokenUser, appState, xLinkId, isBackToPreviousAppIconShown, _a, courses, currentBackTitle, selectedCourse, SHERPATH, isCSApp, sherpathFamilyTitles, isSherpathFamilySource, appLinkingSessionData, _b, _c, outPostBody, srcApp, targetApp, performanceReportPage, keptTargetApp, originSrcApp, breadcrumbBackTitle, isbns, newToken;
    var _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                tokenUser = ELSTokenHelper.getUser();
                appState = getState()[AppConstant.reduxResources.APP_STATE];
                xLinkId = appState.xLinkId, isBackToPreviousAppIconShown = appState.isBackToPreviousAppIconShown, _a = appState.courses, courses = _a === void 0 ? [] : _a, currentBackTitle = appState.breadcrumbBackTitle;
                selectedCourse = courses.find(function (c) { return c.id === courseSectionId; });
                if (!selectedCourse) return [3 /*break*/, 6];
                if (((_d = tokenUser === null || tokenUser === void 0 ? void 0 : tokenUser.appParams) === null || _d === void 0 ? void 0 : _d.courseId) === courseSectionId) {
                    return [2 /*return*/];
                }
                dispatch(setCourseSectionInfo(selectedCourse));
                dispatch(appActions.setSelectedCourse(courseSectionId));
                SHERPATH = EXTERNAL_APP_INFO.APP_LINKING.SHERPATH;
                isCSApp = isCSAppByCourseSection(selectedCourse);
                if (!!xLinkId) return [3 /*break*/, 1];
                sherpathFamilyTitles = [SHERPATH.backTitle, CS_APP_NAME, EAB_APP_NAME];
                isSherpathFamilySource = !currentBackTitle || sherpathFamilyTitles.includes(currentBackTitle);
                if (!isBackToPreviousAppIconShown) {
                    dispatch(appActions.setBreadcrumbBackTitle(''));
                }
                else if (isSherpathFamilySource) {
                    dispatch(appActions.setBreadcrumbBackTitle(isCSApp ? CS_APP_NAME : SHERPATH.backTitle));
                }
                return [3 /*break*/, 4];
            case 1: return [4 /*yield*/, fetchSessionDataFromExternalApp(xLinkId)];
            case 2:
                appLinkingSessionData = _e.sent();
                _b = (appLinkingSessionData === null || appLinkingSessionData === void 0 ? void 0 : appLinkingSessionData.data) || {}, _c = _b.outPostBody, outPostBody = _c === void 0 ? {} : _c, srcApp = _b.srcApp, targetApp = _b.targetApp;
                performanceReportPage = outPostBody.performanceReportPage, keptTargetApp = outPostBody.keptTargetApp;
                return [4 /*yield*/, resolveOriginSrcApp(outPostBody, srcApp)];
            case 3:
                originSrcApp = _e.sent();
                breadcrumbBackTitle = getBreadcrumbBackTitle({ performanceReportPage: performanceReportPage, srcApp: srcApp, targetApp: targetApp, courseSection: selectedCourse, originSrcApp: originSrcApp, keptTargetApp: keptTargetApp });
                dispatch(appActions.setBreadcrumbBackTitle(breadcrumbBackTitle));
                _e.label = 4;
            case 4:
                isbns = getCourseSectionIsbns(selectedCourse);
                return [4 /*yield*/, appLinkingHelper.getTokenSwitchCourse({
                        courseId: courseSectionId,
                        userId: userId,
                        sessionId: tokenUser.sessionId,
                        appId: tokenUser.appParams.appId,
                        isbns: isbns
                    })];
            case 5:
                newToken = _e.sent();
                if (newToken) {
                    ELSTokenHelper.storeToken(newToken);
                }
                _e.label = 6;
            case 6: return [2 /*return*/];
        }
    });
}); }; };
var actions = {
    setCourses: setCourses,
    getCourses: getCourses,
    setCourseSectionInfo: setCourseSectionInfo,
    restoreState: restoreState,
    setIsCourseFetching: setIsCourseFetching,
    switchCourse: switchCourse
};
var reducer = handleActions((_a = {},
    _a[actions.restoreState] = function (state, _a) {
        var payload = _a.payload;
        return state.merge(payload);
    },
    _a[actions.setCourses] = function (state, _a) {
        var _b;
        var payload = _a.payload;
        var instructor = (_b = payload.data) === null || _b === void 0 ? void 0 : _b.find(function (item) { return item.type === 'Ins'; });
        return Immutable.set(state, 'courses', instructor ? instructor.courseSections : []);
    },
    _a[actions.setCourseSectionInfo] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'courseSectionInfo', payload);
    },
    _a[actions.setIsCourseFetching] = function (state, _a) {
        var payload = _a.payload;
        return Immutable.set(state, 'isCourseFetching', payload);
    },
    _a), initialState);
var getCoursesState = function (state) { return state[AppConstant.reduxResources.COURSES_STATE]; };
var selectors = {
    getCourses: createSelector(getCoursesState, function (state) { return state.courses; }),
    getCourseSectionInfo: createSelector(getCoursesState, function (state) { return state.courseSectionInfo; }),
    getIsCourseFetching: createSelector(getCoursesState, function (state) { return state.isCourseFetching; })
};
export { actions as courseActions, reducer as coursesReducer, selectors as courseSelectors };
export { initialState as coursesInitialState };
